import Input from '@/components/Input'
import Ticker from '@/components/Ticker'
import {markRaw} from 'vue'

export const template = 
    {
        type: 'ticker',
        name: 'ticker',
        text: '',
        cta: [],
        lineBreak: false,
        startInEditMode: true,
        hasBeenConfirmed: false,
        template: markRaw(Input),
        view: markRaw(Ticker)
    }
